const PbxxRecord = require('../pbxx_record')

module.exports = class LocalAdsBalance extends PbxxRecord {
  static get class_name() {
    return 'LocalAdsBalance'
  }
}
